import PromoSingleSection from './promo-single-section';

export default PromoSingleSection;
